//
import Model from '@/models/Model'

/**
 * @class
 */
export default class PchPurchaseCreditNote extends Model {

    /**
     * { item_description }
     */
    static includes = [
        'pch_provider',
        'pch_provider_branch_offices',
    ]

    /**
     * { function_description }
     *
     * @return     {PchPurchaseCreditNote}  The pch purchase credit note.
     */
    cancelPurchaseDebitNote() {
        return new PchPurchaseCreditNote({
            id: 'cancel_debit_note'
        })
    }

    /**
     * { property_description }
     *
     * @type       {<type>}
     */
    get net_total() {
    	return this.new_subtotal
    }

    /**
     * { property_description }
     *
     * @type       {<type>}
     */
    set net_total(val) {

        //
        const extra_tax     = Number(this.extra_tax || 0)

        //
    	this.iva 			= Math.round(Math.max(val * 0.19, 1))
    	this.total 			= Math.round(val * 1.19) + extra_tax
    	this.new_subtotal 	= val
    }

    /**
     * { property_description }
     *
     * @type       {<type>}
     */
    get pch_provider_business_name() {
    	return this.pch_provider ? this.pch_provider.business_name : '-'
    }

    reset() {

        //
        this.document_type = this.invoice_number ? 0 : 1
        this.pch_provider_branch_offices = this.pch_provider.pch_provider_branch_offices || []
        
        //
        return this
    }

    /**
     * { function_description }
     *
     * @return     {string}  { description_of_the_return_value }
     */
    resource() {
        return 'pch_purchase_credit_note'
    }

    /**
     * Returns a create representation of the object.
     *
     * @return     {<type>}  Create representation of the object.
     */
    toCreate() {
        return this.clean([
            'pch_provider_branch_offices_id',
            'pch_provider_id',
            'emission_date',
            'payment_date',
            'invoice_number',
            'credit_note_number',
            'replacing_type',
            'extra_tax',
            'new_subtotal',
            'iva',
            'total',
        ])
    }

    /**
     * Returns a create representation of the object.
     *
     * @return     {<type>}  Create representation of the object.
     */
    toCancelPurchaseDebitNote() {
    	return this.clean([
            'pch_provider_branch_offices_id',
            'pch_provider_id',
            'emission_date',
            'payment_date',
            'credit_note_number',
            'debit_note_number',
        ])
    }
}
